<template>

    <NotificationMessage :avatar="message.avatar"
        :text="'We suggest sending ' + message.customerName + ' a message explaining why you declined.'"
    />

</template>

<script>
import NotificationMessage from '@/components/inbox/messagesCard/shared/NotificationMessage.vue';

export default {
    components: {
        NotificationMessage
    },
    props: {
        message: {
            type: Object
        }
    }
};
</script>
